import "./searchInput.scss";
import SeachIcon from "assets/imgs/icons/searchIcon.svg";
import AddRounded from "assets/imgs/icons/addRounded.svg";
import { AutoComplete } from "rsuite";
import ReactSearchBox from "react-search-box";

function SearchInput({
  btn = false,
  appendItem = null,
  onBtnClick,
  data = [],
  variant = "underline",
  placeholder,
  wrapperClass = "",
  rounded = false,
  value,
  onChange,
  onSelect,
}) {
  let searchInputWrapperClass = "searchInput__unerline_wrapper";
  let searchInputInputClass = "search-input-input-underline";
  let additionalWrapperClass = "";

  if (variant === "primary") {
    searchInputWrapperClass = "searchInput__primary_wrapper";
    searchInputInputClass = "search-input-input-primary";
  }

  if (variant === "primary_white") {
    searchInputWrapperClass = "searchInput__primary_white_wrapper";
    searchInputInputClass = "search-input-input-primary_white";
  }

  if (rounded === true) {
    additionalWrapperClass = "searchInput__rounded";
  }

  return (
    <div
      className={`${searchInputWrapperClass} search-input-wrapper ${wrapperClass} ${additionalWrapperClass}`}
    >
      <img src={SeachIcon} alt="" className="search-input-search-icon" />
      <div className={`w-100 ${searchInputInputClass} search-input-input`}>
        <AutoComplete
          placeholder={placeholder}
          data={data}
          value={value}
          onChange={onChange}
          onSelect={onSelect}
        />
      </div>
      {btn && (
        <button onClick={onBtnClick} className="search-input-btn">
          <img className="search-input-btn-icon" src={AddRounded} alt="" /> Add
          School
        </button>
      )}
      {appendItem && appendItem}
    </div>
  );
}

export default SearchInput;
